import {DestroyRef, inject, provideAppInitializer} from '@angular/core';
import {Actions, ofActionDispatched, Store} from '@ngxs/store';
import {HttpClient} from '@angular/common/http';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {CreateAsset, CreateAssetFailure, CreateAssetSuccess} from '../../assets/+state/actions';
import {catchError, switchMap, withLatestFrom} from 'rxjs';
import {Router} from '@angular/router';
import {getApiUrl} from '../helpers/env.helper';

export const provideCreateAssetInit = provideAppInitializer(() => {
  const actions = inject(Actions);
  const store = inject(Store);
  const destroyRef = inject(DestroyRef);
  const router = inject(Router);

  const httpClient = inject(HttpClient);

  actions.pipe(
    ofActionDispatched(CreateAsset),
    withLatestFrom(getApiUrl('assets')),
    switchMap(([{asset}, url ]) => httpClient.post(`${url}/assets`, {
      serial_number: asset.serialNumber
    }).pipe(
      switchMap(() => store.dispatch(new CreateAssetSuccess())),
      switchMap(() => router.navigate(['/assets'])),
      catchError((err) => store.dispatch(new CreateAssetFailure(err)))
    )),
    takeUntilDestroyed(destroyRef)
  ).subscribe();
});
